// ============================================================
// ENGINE HELPERS
// ============================================================

export function sameDay(date1, date2) {

    const a = new Date(date1)
    const b = new Date(date2)

    return (
        a.getFullYear() === b.getFullYear() &&
        a.getMonth() === b.getMonth() &&
        a.getDate() === b.getDate()
    )

}

// ============================================================
// HAS GENERATION WINDOW OPENED?
// ============================================================

export function generationWindowOpen(
    now = new Date(),
    generationHour = 4
) {

    return now.getHours() >= generationHour

}